import AOS from 'aos/dist/aos.js';
import pswp from '../pswp';

export default {
    init() {
        // JavaScript to be fired on all pages

        pswp()

        $('[data-toggle="tooltip"]').tooltip()

        $('.ll-btn--has-modal').on('click', function (e) {
            e.preventDefault()

            let modalTitle = $(this).attr('data-modal-title');

            if (typeof modalTitle !== typeof undefined && modalTitle !== false) {
                let modal = $('[data-modal-title=' + modalTitle + ']')
                let overlay = $('.ll-overlay')

                modal.fadeIn()
                overlay.fadeIn()
                $('html, body').addClass('ll-overflow-hidden ll-h-100')
            } else {
                let parentSection = $(this).parents('section')
                let modal = parentSection.next('.ll-modal--wrapper')
                let overlay = modal.find('.ll-overlay')

                modal.fadeIn()
                overlay.fadeIn()
                $('html, body').addClass('ll-overflow-hidden ll-h-100')
            }
        })

        $('.ll-overlay, .ll-modal--close').on('click', function () {
            $('.ll-modal--wrapper, .ll-overlay').fadeOut()
            $('html, body').removeClass('ll-overflow-hidden ll-h-100')
        })

        AOS.init({
            startEvent: 'load',
            disable: () => {
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE');

                return msie > 0;
            },
        });

        //Slider
        $('[data-slider="slick"]').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            appendArrows: $('[data-slick="arrows-quotes"]'),
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 10000,
        })

        //Slider Cards
        $('[data-slider="slider-cards"]').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            appendArrows: $('[data-slick="arrows-slider-cards"]'),
            prevArrow: '<div aria-label="Previous" style="display: flex;" class="ll-slick-prev ll-bg-blue-astral hover:ll-bg-blue-muzli ll-transition-bg ll-mr-2 ll-outline-none ll-justify-center ll-items-center ll-cursor-pointer"><i class="fa fa-chevron-left ll-block ll-text-white" aria-hidden="true"></i></div>',
            nextArrow: '<div aria-label="Next" style="display: flex;" class="ll-slick-next ll-bg-blue-astral hover:ll-bg-blue-muzli ll-transition-bg ll-outline-none ll-justify-center ll-items-center ll-cursor-pointer"><i class="fa fa-chevron-right ll-block ll-text-white" aria-hidden="true"></i></div>',
            accessibility: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

        $('[data-slider="slider-cards"]').on('afterChange', function() {
            if ($(window).width() >= 1024) {
                if ($('.ll-slider-card:nth-of-type(3)').hasClass('slick-current')) {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '#1f5a74')
                } else {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '')
                }
            } else if ($(window).width() >= 768) {
                if ($('.ll-slider-card:nth-of-type(4)').hasClass('slick-current')) {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '#1f5a74')
                } else {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '')
                }
            } else {
                const totalSlides = $('[data-slider="slider-cards"] > .ll-slider-card').length

                if ($('.ll-slider-card:nth-of-type('+ totalSlides +')').hasClass('slick-current')) {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '#1f5a74')
                } else {
                    $('.ll-slider-cards--arrows .ll-slick-next').css('background-color', '')
                }
            }
        })

        //Testimonials Slider
        $('[data-slider="testimonials"]').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            accessibility: true,
            adaptiveHeight: true,
            prevArrow: '<button aria-label="Previous" class="ll-w-1/6"><i class="fa fa-chevron-left ll-pr-4" aria-hidden="true"></i></button>',
            nextArrow: '<button aria-label="Next" class="ll-w-1/6"><i class="fa fa-chevron-right ll-pl-4" aria-hidden="true"></i></button>',
        })

        //Home Projects Slider
        $('[data-slider="home-banner"]').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 8000,
        })

        //Home Banner Titles
        $('[data-slider="home-titles"]').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: false,
            dots: false,
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 10000,
            asNavFor: $('[data-slider="home-banner"]'),
            prevArrow: '<button aria-label="Previous" class="ll-slick-prev ll-h-30px ll-w-40px ll-bg-blue-cerulean"><i class="fa fa-chevron-left ll-text-white" aria-hidden="true"></i></button>',
            nextArrow: '<button aria-label="Next" class="ll-slick-next ll-h-30px ll-w-40px ll-bg-blue-bondi"><i class="fa fa-chevron-right ll-text-white" aria-hidden="true"></i></button>',
            appendArrows: $('[data-slick="home-titles-arrows"]'),
        })

        //Generic Images Slider - Projects Photo Gallery
        $('[data-slider="images"]').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            accessibility: true,
            autoplay: true,
            autoplaySpeed: 10000,
            prevArrow: '<button aria-label="Previous" class="ll-slick-prev-photo-gallery ll-z-90 ll-h-30px ll-w-40px ll-mr-4"><i class="fa fa-chevron-left ll-text-blue-bondi ll-pr-4" aria-hidden="true"></i></button>',
            nextArrow: '<button aria-label="Next" class="ll-slick-next-photo-gallery ll-z-90 ll-h-30px ll-w-40px ll-ml-4"><i class="fa fa-chevron-right ll-text-blue-bondi ll-pl-4" aria-hidden="true"></i></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

        //Timeline Slider
        $('[data-slider="timeline"]').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            centerMode: false,
            arrows: true,
            prevArrow: '<button aria-label="Previous" class="ll-slick-prev ll-h-50px ll-w-80px ll-mr-2 ll-bg-blue-astral"><i class="fa fa-chevron-left ll-text-white" aria-hidden="true"></i></button>',
            nextArrow: '<button aria-label="Next" class="ll-slick-next ll-h-50px ll-w-80px ll-bg-blue-astral"><i class="fa fa-chevron-right ll-text-white" aria-hidden="true"></i></button>',
            dots: false,
            appendArrows: $('[data-slick="timeline-arrows"]'),
            accessibility: true,
            autoplay: false,
            touchMove: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                    },
                },
            ],
        })

        //Timeline Slider - Desktop
        $('[data-slider="timeline--desktop"]').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            centerMode: false,
            arrows: true,
            prevArrow: '<button aria-label="Previous" class="ll-slick-prev ll-h-50px ll-w-80px ll-mr-2 ll-bg-blue-astral"><i class="fa fa-chevron-left ll-text-white" aria-hidden="true"></i></button>',
            nextArrow: '<button aria-label="Next" class="ll-slick-next ll-h-50px ll-w-80px ll-bg-blue-astral"><i class="fa fa-chevron-right ll-text-white" aria-hidden="true"></i></button>',
            dots: false,
            appendArrows: $('[data-slick="timeline-arrows--desktop"]'),
            accessibility: true,
            autoplay: false,
            touchMove: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                    },
                },
            ],
        })

        //Project Card Mobile Hover Fallback
        let timer
        let delay = 800

        $('.ll-projects-card').on('click tap mouseenter', (e) => {
            let $this = $(e.currentTarget)
            $this
                .find('.ll-projects-card-bottom').toggleClass('ll-top-0')
                .find('.ll-projects-card-bottom-content').toggleClass('ll-opacity-100')

            timer = setTimeout(() => {
                $this.find('.ll-overflow-trigger').toggleClass('ll-overflow-x-hidden ll-overflow-y-auto')
            }, delay)
        })

        $('.ll-projects-card').on('mouseleave', (e) => {
            let $this = $(e.currentTarget)
            $this
                .find('.ll-overflow-trigger').removeClass('ll-overflow-x-hidden ll-overflow-y-auto')
                .find('.ll-projects-card-bottom').removeClass('ll-top-0')
                .find('.ll-projects-card-bottom-content').removeClass('ll-opacity-100')

            clearTimeout(timer)
        })
    }
    ,
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js